import { useNavigate } from 'react-router-dom'
import { ToastAction } from '@/components/ui/toast'

/**
 * A toast's button that takes you to what just finished: the new radar
 * ideas, the saved draft, the chat whose reply landed. A light key, like
 * every other button. A hash in `to` scrolls to that section once the page
 * is there.
 */
export function ToastGo({ label, to, altText }: { label: string; to: string; altText?: string }) {
  const navigate = useNavigate()
  return (
    <ToastAction
      altText={altText ?? label}
      className="key key-lite h-8 rounded-md border px-3 text-sm font-medium text-foreground hover:bg-transparent"
      onClick={() => {
        navigate(to)
        const hash = to.split('#')[1]
        if (hash) {
          // After the route renders; the section may mount a frame later.
          window.setTimeout(() => document.getElementById(hash)?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 120)
        }
      }}
    >
      {label}
    </ToastAction>
  )
}
